import React from "react";
import classNames from "classnames";
import { Transaction } from "@common/types/transaction";
import { useIsDateLocked } from "@hooks/useIsDateLocked";
import { useIsGlFirst } from "@hooks/useIsGlFirst";
import { toDisplayDateOnly } from "@helpers/date";
import { TransactionDateColumnContent } from "../../../../transactions/ListItem/TransactionDateColumnContent";
import { TransactionLockColumnContent } from "../../../../transactions/ListItem/TransactionLockColumnContent";
import { TransactionDescriptionColumnContent } from "../../../../transactions/ListItem/TransactionDescriptionColumnContent";
import { TransactionAmount } from "../../../../transactions/TransactionAmount";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { TransactionCategoryColumnContent } from "../../../../transactions/ListItem/TransactionCategoryColumnContent";
import { TransactionAccountColumnContent } from "../../../../transactions/ListItem/TransactionAccountColumnContent";
import { TransactionCashLedgerColumnContent } from "@components/transactions/ListItem/TransactionCashLedgerColumnContent";
import styles from "./RuleTransactionsPreview.module.scss";

interface Props {
    transaction: Transaction;
}

export const MatchingTransaction: React.FC<Props> = ({ transaction }) => {
    const { enabled: isGlFirst } = useIsGlFirst();
    const isLocked = useIsDateLocked(
        transaction.entity.id,
        toDisplayDateOnly(transaction.dateOnly ?? transaction.date),
    );

    return (
        <div className={styles.transactionContent}>
            <div className={styles.lockColumn}>
                <TransactionLockColumnContent isLocked={isLocked} />
            </div>
            <div className={styles.dateColumn}>
                <TransactionDateColumnContent transaction={transaction} />
            </div>
            <div className={styles.descriptionColumn}>
                <TransactionDescriptionColumnContent
                    transaction={transaction}
                />
            </div>
            <div className={styles.categoryColumn}>
                {isGlFirst ? (
                    <TransactionCashLedgerColumnContent
                        transaction={transaction}
                    />
                ) : (
                    <TransactionCategoryColumnContent
                        transaction={transaction}
                    />
                )}
            </div>
            <TransactionAccountColumnContent transaction={transaction} />
            <div
                className={classNames(styles.amountColumn, styles.amountValue)}
            >
                <TransactionAmount transaction={transaction} addSign color />
            </div>
            <div className={styles.entityColumn}>
                <EntityAvatar entity={transaction.entity} size="xs" />
            </div>
        </div>
    );
};
